export {default as EquipeSlider} from "./EquipeSlider";